// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__AeW9x"};